import { useEffect, useMemo, useState } from 'react';
import { Tag } from '~/components/srp/MainLayout/constants';

export const nameLimit = 150;

export default function useAlertName(
  filterTags: Tag[]
): [string, React.Dispatch<React.SetStateAction<string>>] {
  const defaultAlertName = useMemo(
    () =>
      filterTags
        .map(tag => tag.tagName)
        .join(' • ')
        .substring(0, nameLimit),
    [filterTags]
  );

  const [alertName, setAlertName] = useState(defaultAlertName);

  useEffect(() => {
    setAlertName(defaultAlertName);
  }, [defaultAlertName]);

  return [alertName, setAlertName];
}
